import { Injectable } from "@angular/core";
import { PrelevementAir } from "src/app/domain/Air/prelevement-air";
import { mapper } from "src/app/tools/mapping/mapper";
import { db } from "../db";
import { PrelevementRepository } from "./prelevement.repository";
import { PrelevementAirEntity } from "../prelevement-air.entity";
import { ZoneEntity } from "../zone.entity";
import { AppareilRepository } from "./appareil.repository";

@Injectable({
    providedIn: 'root',
})
export class PrelevementAirRepository {
    constructor(
        private prelevementRepository: PrelevementRepository,
    ) { }

    async getPrelevementAirEntityById(id: number) {
        return await db.prelevementAirs.where('Id').equals(id).first(async ze => {
            return ze;
        });
    }

    async getPrelevementAirById(id: number) {
        return await db.prelevementAirs.where('Id').equals(id).first(async ze => {
            const z = mapper.map(ze, PrelevementAirEntity, PrelevementAir);

            if (ze?.PrelevementId) {
                z.Prelevement = await this.prelevementRepository.getPrelevementById(ze?.PrelevementId)
            }

            return z;
        });
    }

    async attachPrelevementAir(pa: PrelevementAir, zone: ZoneEntity) {
        let paId: number;
        const pae = mapper.map(pa, PrelevementAir, PrelevementAirEntity);

        // const ie = await this.zoneRepository.getZoneEntityById(zoneId);
        paId = await db.prelevementAirs.add(pae);
        zone.PrelevementAirIds = zone?.PrelevementAirIds ? [...zone.PrelevementAirIds, paId] : [paId]
        await db.zones.update(zone.Id!, {
            PrelevementAirIds: zone?.PrelevementAirIds
        });

        if (pa.Prelevement) {
            await this.prelevementRepository.attachPrelevementToAir(pa.Prelevement, paId);
        }

        return paId;
    }
}